/** Relative segments under `/admin` (no leading slash). */
export const adminPaths = {
  company: 'company',
} as const;
